import { render, staticRenderFns } from "./ShuttleAnimation.vue?vue&type=template&id=a864c10a&scoped=true&"
import script from "./ShuttleAnimation.vue?vue&type=script&lang=js&"
export * from "./ShuttleAnimation.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleAnimation.vue?vue&type=style&index=0&id=a864c10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a864c10a",
  null
  
)

export default component.exports